import classes from './ForgotPassword.module.css'
import Button from "../common/Button"
import Card from "../common/Card"
import InputBox from "../common/interactive/InputBox"
import PannelBody from "../fragments/PannelBody"
import PannelHeader from "../fragments/PannelHeader"
import { useState } from 'react'
import OtpConfirmation from './OtpConfirmation'
import { userForgaotpassword } from '../../lib/fetchApi'
import { useDispatch } from 'react-redux'
import { notificationActions } from '../../store/notifications'

const ForgotPassword =  ({close}) => {
    const [nextStep, setNextStep] = useState(false)
    const [emailUsed, setEmailused] = useState(null)
    const [isLoading, setIsLoading] = useState(false)
    const dispatch = useDispatch()

    const ForgotPasswordHandler = async (event) => {
        event.preventDefault()

        setIsLoading(true)
        try {
            const fd = new FormData(event.target)

            const data = Object.fromEntries(fd.entries())

            if (data.user_email) {
                const forgotPass = await userForgaotpassword({email: data.user_email})
                
                if (forgotPass?.errorMessage) {
                    dispatch(notificationActions.setError(forgotPass))
                } else {
                    setEmailused(data.user_email)
                    setNextStep(true)
                }            
            }
        } finally {
            setIsLoading(false)
        }
    }


    return <Card>
        {close && <button onClick={close} className={classes.close_button}>
            <i className='ti ti-x'></i>
            <span className='sr-only'>close modal</span>
        </button>}
        <PannelHeader padding='large'>
            {!nextStep && <h2>Forgot Password?</h2>}
            {nextStep && <h2>Change password</h2>}
        </PannelHeader>
        <PannelBody padding='large'>
            
            {!nextStep && <>
                <div className={classes.text}>
                    <p>Enter your registered email below to receive password reset instruction</p>
                </div>
                <form onSubmit={ForgotPasswordHandler}>
                    <InputBox label="Email Address" type="email" name="user_email" required={true} icon='ti ti-mail' />                
                    <div className={classes.form_footer}>
                        <Button type='submit' isLoading={isLoading} width={'full'}>
                            Reset Password 
                            <i className='ti ti-chevron-right'></i>
                        </Button>
                    </div>
                </form>
            </>}

            {nextStep && <OtpConfirmation email={emailUsed} action={close}/>}
        </PannelBody>
    </Card>
}

export default ForgotPassword